import React from 'react';
import TodaysDate from './TodaysDate';
import PropTypes from 'prop-types';
import './PageHeader.css';

export const PageHeader = props => {
    return (

        <div className="pageHeader">
            <div className="headerLeft">
                <h3 className="pageTitle">{props.pageTitle}</h3>
                {props.showTodaysDate &&
                    (<TodaysDate />)
                }
            </div>

            {props.pageHeaderCenter && (
                props.pageHeaderCenter
            )}
            {props.pageHeaderRight &&
                (
                    props.pageHeaderRight
                )
            }

        </div>
    );
};

PageHeader.propTypes = {
    pageTitle: PropTypes.string.isRequired,
    showTodaysDate: PropTypes.bool
};
PageHeader.defaultProps = {
    pageTitle: 'Page Title',
    showTodaysDate: true
};

export const PageHeaderRight = props => (
    <div className="headerRight">
        {props.children}
    </div>
);

export const PageHeaderCenter = props => (
    <div className="headerCenter">
        {props.children}
    </div>
);



// WEBPACK FOOTER //
// ./src/components/shared/PageHeader.js